export const colors = {
	liteGray: '#9D9D9D',
	liteBackground: '#0A0A08FF',
	graySecondary: '#3F3F3F',
	gray: '#E0E0E0',
	darkGray: '#212121',
	primary: '#FF3F3F',
	borderGray: '#4E4F52',
	liteLink: '#e0f3f3',
	link: '#b4e1e0',
	darkLink: '#6bc3c3',
	cartridge: {
		red: '#FF3F3F',
		blue: '#468CF4',
		gold: '#BEA379',
		gray: '#9D9D9D',
		green: '#6AAD38',
	},
	danger: '#FF3F3F',
};
